<template>
  <div id="smartTown" class="product-page">
    <!-- 标题区域 -->
    <h1 class="page-title">传染病智能流调系统</h1>

    <!-- 正文内容区域 -->
    <div class="page-content">
      <!-- 第1章 产品概述 -->
      <div class="text-section">
        <h2 class="chapter-title">一、产品概述</h2>
        <p class="content-paragraph">
          传染病智能流调系统面向疾病预防控制机构，融合病例报告、实验室检测、通信信令、交通出行、场所扫码等多源数据，辅助流调人员快速开展流行病学调查，自动绘制传播链条、精准判定密切接触者与风险场所，提升流调效率与准确性，为疫情早发现、早报告、早隔离、早治疗争取宝贵时间。
        </p>
        <p class="content-paragraph">
          系统构建“采集—分析—处置—反馈”闭环：支持个案调查表在线填报与移动端流调采集，运用时空伴随分析、传播链图谱与聚集性预警模型开展智能研判，并打通跨区域协查函流转、隔离管控跟踪与流调报告自动生成，实现流调工作标准化、协同化与智能化。
        </p>

        <!-- 核心能力 -->
        <div class="capability-grid">
          <div class="capability-card">
            <h3 class="capability-title">流调采集</h3>
            <ul class="capability-list"><li>个案调查表</li><li>移动端流调</li><li>活动轨迹采集</li><li>密接判定</li><li>次密接管理</li><li>样本采集关联</li><li>流调质控</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">智能研判</h3>
            <ul class="capability-list"><li>传播链图谱</li><li>时空伴随分析</li><li>风险点位识别</li><li>聚集性预警</li><li>感染来源推断</li><li>潜伏期推算</li><li>趋势预测</li></ul>
          </div>
          <div class="capability-card">
            <h3 class="capability-title">协同处置</h3>
            <ul class="capability-list"><li>协查函流转</li><li>跨区域协查</li><li>隔离管控跟踪</li><li>风险区划定</li><li>报告自动生成</li><li>数据统计</li></ul>
          </div>
        </div>
      </div>

      <!-- 第2章 产品截图 -->
      <div class="text-section">
        <h2 class="chapter-title">二、产品截图</h2>
        <p class="shot-note">以下为系统功能示意，实际界面以项目交付成果为准。</p>
        <div class="shot-grid">
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ld-dashboard.svg"
              alt="海南华德科技有限公司 传染病智能流调系统 - 疫情态势大屏 · 传播链与风险研判"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">01</span>疫情态势大屏 · 传播链与风险研判
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ld-investigate.svg"
              alt="海南华德科技有限公司 传染病智能流调系统 - 个案流调 · 轨迹采集与密接判定"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">02</span>个案流调 · 轨迹采集与密接判定
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ld-mobile.svg"
              alt="海南华德科技有限公司 传染病智能流调系统 - 移动端流调 · 现场采集与快速上报"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">03</span>移动端流调 · 现场采集与快速上报
            </figcaption>
          </figure>
          <figure class="shot-card">
            <img
              src="@/assets/images/20250724/ruanjian/ld-coop.svg"
              alt="海南华德科技有限公司 传染病智能流调系统 - 跨区域协查 · 协查函流转与管控跟踪"
              loading="lazy"
            />
            <figcaption>
              <span class="shot-index">04</span>跨区域协查 · 协查函流转与管控跟踪
            </figcaption>
          </figure>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "smartTown",
  data() {
    return {};
  },
};
</script>
<style scoped>
/* 全局容器样式 */
.product-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 40px 20px;
  font-family: "Poppins", "Microsoft YaHei", "PingFang SC", sans-serif;
  background-color: var(--light-bg);
  min-height: 100vh;
}

/* 标题样式 */
.page-title {
  font-weight: 700;
  font-size: 32px;
  color: var(--text-color);
  text-align: center;
  margin: 0 auto 50px;
  padding-bottom: 15px;
  border-bottom: 3px solid var(--primary-color1);
  display: inline-block;
  width: 100%;
  letter-spacing: 1px;
}

/* 内容容器 */
.page-content {
  background-color: var(--white);
  padding: 50px 30px;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

/* 章节区域 */
.text-section {
  margin: 20px 0 60px;
}
.text-section:last-child {
  margin-bottom: 20px;
}

/* 章节标题 */
.chapter-title {
  font-weight: 700;
  font-size: 20px;
  color: var(--text-color);
  margin: 10px 0 25px;
  padding-left: 10px;
  border-left: 4px solid var(--primary-color1);
  line-height: 1.4;
}

/* 正文段落 */
.content-paragraph {
  line-height: 1.8;
  font-weight: 400;
  color: var(--text-color2);
  margin: 8px 0 22px;
  text-indent: 2em;
  font-size: 16px;
  text-align: justify;
}
.content-paragraph strong {
  color: var(--primary-color1);
  font-weight: 600;
}

/* 核心能力卡片 */
.capability-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}
.capability-card {
  background-color: var(--light-bg);
  border-radius: 10px;
  padding: 22px 20px;
  border-top: 3px solid var(--primary-color1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.capability-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.06);
}
.capability-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-color);
  margin: 0 0 14px;
}
.capability-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.capability-list li {
  display: inline-block;
  background-color: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  padding: 4px 12px;
  margin: 0 6px 8px 0;
  font-size: 13px;
  color: var(--text-color2);
  transition: all 0.3s ease;
}
.capability-list li:hover {
  border-color: rgba(230, 0, 76, 0.35);
  color: var(--primary-color1);
}

/* 产品截图 */
.shot-note {
  font-size: 13px;
  color: var(--text-color3);
  margin: -10px 0 22px;
}
.shot-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
}
.shot-card {
  margin: 0;
  background: var(--white);
  border: 1px solid #f0f0f0;
  border-radius: 12px;
  overflow: hidden;
  transition: transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease;
}
.shot-card:hover {
  transform: translateY(-4px);
  border-color: rgba(230, 0, 76, 0.25);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.06), 0 10px 28px rgba(0, 0, 0, 0.08);
}
.shot-card img {
  display: block;
  width: 100%;
  height: auto;
}
.shot-card figcaption {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 14px 16px;
  font-size: 14px;
  color: var(--text-color);
  border-top: 1px solid #f2f2f2;
  background: var(--white);
}
.shot-index {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 700;
  color: var(--primary-color1);
  background: rgba(230, 0, 76, 0.08);
  border-radius: 4px;
  padding: 2px 7px;
}

/* 响应式 */
@media (max-width: 991px) {
  .capability-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 767px) {
  .product-page {
    padding: 24px 14px;
  }
  .page-title {
    font-size: 24px;
    margin-bottom: 30px;
  }
  .page-content {
    padding: 28px 18px;
  }
  .capability-grid,
  .shot-grid {
    grid-template-columns: 1fr;
  }
  .content-paragraph {
    font-size: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/softwareWs8.vue